import React from 'react';

import './style.sass';

import attentionItem from 'assets/img/icons/attention.svg';

type Props = {
    title: string,
    desc: string,
};

export const AttentionMessage = ({ title, desc }: Props) => {
    return (
        <div className="attention-message">
            <div className="attention-message__icon-wrapper">
                <img src={attentionItem} className="attention-message__icon" />
            </div>

            <div className="attention-message__title">
                <h1 className="title-h1 dark-violet">Oops...</h1>
                <h1 className="title-h1 dark-violet">{title}</h1>
            </div>

            <p className="attention-message__desc p2-medium grey-1">{desc}</p>
        </div>
    );
};
